import {Vue, Component, Watch} from "vue-property-decorator";
import DfBrand from "@/vue/domain/brand/df-brand";
import DfStore from "@/vue/domain/store/df-store";

@Component({
  components: {
    DfErrorCard: () => import(/* webpackChunkName: 'df-error-card' */ "@/vue/components/df-page-error/df-error-card/df-error-card.vue"),
  }
})
export default class DfPageErrorComponent extends Vue {
  private errorCode: string = null;

  get brand(): DfBrand {
    return this.$store.getters.brand;
  }

  get currentStore(): DfStore {
    return this.$store.getters.currentStore;
  }

  get errorDescription(): string {
    let errorDescription = "";
    switch (this.errorCode) {
      case "404":
        errorDescription = this.$t("df-page-error.error-type.404").toString();
        break;
      case "500":
        errorDescription = this.$t("df-page-error.error-type.500").toString();
        break;
    }
    return errorDescription;
  }

  @Watch("$route.params.errorCode", { immediate: true })
  private errorCodeChange() {
    document.title = `${this.$t("df-page-error.title").toString()} | ${this.brand.description}`;
  }

  beforeMount() {
    this.errorCode = this.$route.params.errorCode.toString();
  }

  private goToHome() {
    this.$router.push({ name: "home-store", params: { storeAlias: this.currentStore.alias } });
  }
}
